"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosApiAdapter = void 0;
var axios_1 = __importDefault(require("axios"));
var nprogress_1 = __importDefault(require("nprogress"));
var ioc_1 = require("../ioc");
var AxiosApiAdapter = /** @class */ (function () {
    function AxiosApiAdapter() {
        Object.defineProperty(this, "unauthenticatedInterceptor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "authTokenSet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    Object.defineProperty(AxiosApiAdapter.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (baseUrl) {
            axios_1.default.defaults.baseURL = baseUrl;
            axios_1.default.interceptors.request.use(function (config) {
                nprogress_1.default.start();
                return config;
            });
            if (!this.authTokenSet) {
                this.useUnauthenticatedInterceptor();
            }
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (resource, config) {
            return axios_1.default.get(resource, config);
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "post", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (resource, data, config) {
            return axios_1.default.post(resource, data, config);
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "put", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (resource, data, config) {
            return axios_1.default.put(resource, data, config);
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (resource, config) {
            return axios_1.default.delete(resource, config);
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "custom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (config) {
            return axios_1.default.request(config);
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "setAuthenticationToken", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (token) {
            axios_1.default.defaults.headers.common['Authorization'] = "Bearer " + token;
            this.authTokenSet = true;
            this.useAuthenticatedInterceptor();
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "clearAuthenticationToken", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            axios_1.default.defaults.headers.common = {};
            this.authTokenSet = false;
            this.useUnauthenticatedInterceptor();
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "useAuthenticatedInterceptor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.unauthenticatedInterceptor = axios_1.default.interceptors.response.use(function (response) {
                nprogress_1.default.done();
                return response;
            }, function (error) {
                nprogress_1.default.done();
                if (error.request.status === 401) {
                    ioc_1.getCoreContainer()
                        .getAll(ioc_1.CORE_TYPES.LogoutUseCase)
                        .forEach(function (useCase) { return useCase.execute(); });
                }
                else if (error.request.status === 403) {
                    ioc_1.getCoreContainer()
                        .getAll(ioc_1.CORE_TYPES.ForbiddenUseCase)
                        .forEach(function (useCase) { return useCase.execute(); });
                }
                return Promise.reject(error);
            });
        }
    });
    Object.defineProperty(AxiosApiAdapter.prototype, "useUnauthenticatedInterceptor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            axios_1.default.interceptors.response.eject(this.unauthenticatedInterceptor);
            axios_1.default.interceptors.response.use(function (response) {
                nprogress_1.default.done();
                return response;
            }, function (error) {
                nprogress_1.default.done();
                return Promise.reject(error);
            });
        }
    });
    return AxiosApiAdapter;
}());
exports.AxiosApiAdapter = AxiosApiAdapter;
//# sourceMappingURL=AxiosApiAdapter.js.map